/**
 * Unix Sleep
 *
 * @param {Number} ms
 *
 * @return {Promise}
 */
export default (ms = 500) => new Promise((resolve) => setTimeout(resolve, ms));
